import Image from "next/image";
import logo from "@rosette/assets/src/rosettegames/logo.png";
import Link from "next/link";
import { ROSETTE_URL } from "@rosette/ts/src/business/constants.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface RosetteGamesBannerProps {
    className?: string;
    darkMode?: boolean;
}


export function RosetteGamesBanner({ className, darkMode }: RosetteGamesBannerProps) {
    return (
        <div
            className={cn(
                "flex w-full items-center justify-center mb-4 text-3xl font-bold text-left",
                className ?? null,
            )}>
            <Link
                className="flex flex-row flex-wrap items-center justify-center gap-x-[0.2em] no-underline"
                href={ROSETTE_URL}>
                <div className="leading-0">
                    <Image className="w-[2em] h-[2em]" src={logo} alt="Rosette Games Logo" />
                </div>
                <div
                    className={cn(
                        "leading-[1em] tracking-[0.015em] text-[#53B4EE] pb-[0.1em]",
                        darkMode ? "[text-shadow:-0.05em_-0.05em_0_#111,0.05em_-0.05em_0_#111,-0.05em_0.05em_0_#111,0.05em_0.05em_0_#111]" : null,
                    )}>
                    Rosette
                    <br />
                    Games
                </div>
            </Link>
        </div>
    );
}
